import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home.vue'
import Collections from '@/components/Collections.vue'
import CollectionsAll from '@/components/CollectionsAll.vue'
import Assets from '@/components/Assets.vue'
import Asset from '@/components/Asset.vue'
import CaGranda from "@/components/CaGranda";
import Archaeological from "@/components/Archaeological";
import Archives from "@/components/Archives";
import Buildings from "@/components/Buildings";
import Orchestra from "@/components/Orchestra";
import AssetsBy from "@/components/AssetsBy_unused";
import MapAssets from "@/components/MapAssets_unused";
import AssetsSearch from "@/components/AssetsSearch";
import InMuseums from "@/components/InMuseums.vue";
import Loans from "@/components/Loans";
import Donors from "@/components/Donors";
import About from "@/components/About";
import GoogleArts from "@/components/GoogleArts";
import MapCollections from "@/components/MapCollections";
import CulturalProjects from "@/components/CulturalProjects.vue";
import Cookie from "@/components/Cookie.vue";
import GlobalSearch from "@/components/GlobalSearch.vue";

Vue.use(Router)

export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'home',
            component: Home
        },
        {
            path: '/collections/:idStructure',
            name: 'collections',
            component: Collections
        },
        {
            path: '/collectionsall',
            name: 'collectionsall',
            component: CollectionsAll
        },
        {
            path: '/archaeological',
            name: 'archaeological',
            component: Archaeological
        },
        {
            path: '/buildings',
            name: 'buildings',
            component: Buildings
        },
        {
            path: '/archives',
            name: 'archives',
            component: Archives
        },
        {
            path: '/orchestra',
            name: 'orchestra',
            component: Orchestra
        },
        {
            path: '/culturalprojects',
            name: 'culturalprojects',
            component: CulturalProjects
        },
        {
            path: '/assets/:idCollection',
            name: 'assets',
            component: Assets
        },
        {
            path: '/assetssearch',
            name: 'assetssearch',
            component: AssetsSearch
        },
        {
            path: '/assetsby/:field/:fieldValue',
            name: 'assetsby',
            component: AssetsBy
        },
        {
            path: '/mapcollections',
            name: 'mapcollections',
            component: MapCollections
        },
        {
            path: '/mapassets',
            name: 'mapassets',
            component: MapAssets
        },
        {
            path: '/googlearts',
            name: 'googlearts',
            component: GoogleArts
        },
        {
            path: '/assets',
            name: 'allassets',
            component: Assets
        },
        {
            path: '/asset/:idAsset',
            name: 'asset',
            component: Asset
        },
        {
            path: '/cagranda',
            name: 'cagranda',
            component: CaGranda
        },
        {
            path: '/inmuseums',
            name: 'inmuseums',
            component: InMuseums
        },
        {
            path: '/loans',
            name: 'loans',
            component: Loans
        },
        {
            path: '/donors',
            name: 'donors',
            component: Donors
        },
        {
            path: '/about',
            name: 'about',
            component: About
        },
        {
            path: '/globalsearch',
            name: 'globalsearch',
            component: GlobalSearch
        },
        {
            path: '/cookie',
            name: 'cookie',
            component: Cookie
        },
        {
            path: '/prospettivaintr',
            redirect: '/asset/518'
        },
        {
            path: '/genesislight',
            redirect: '/asset/519'
        },
        {
            path: '/kounellis',
            redirect: '/asset/520'
        },
        {
            path: '/santambrogio',
            redirect: '/asset/214'
        },
        {
            path: '/minerva',
            redirect: '/asset/211'
        },
        {
            path: '/mangiagalli',
            redirect: '/asset/186'
        },
        {
            path: '/rossi',
            redirect: '/asset/181'
        },
        {
            path: '/livini',
            redirect: '/asset/185'
        },
        {
            path: '/pepere',
            redirect: '/asset/176'
        },
        {
            path: '/pestalozza',
            redirect: '/asset/179'
        },
        {
            path: '/candian',
            redirect: '/asset/166'
        },
        {
            path: '/menotti',
            redirect: '/asset/187'
        },
        {
            path: '/perussia',
            redirect: '/asset/177'
        },
        {
            path: '/cattabeni',
            redirect: '/asset/188'
        },
        {
            path: '/polvani',
            redirect: '/asset/180'
        },
        {
            path: '/deotto',
            redirect: '/asset/184'
        },
        {
            path: '/schiavinato',
            redirect: '/asset/182'
        },
        {
            path: '/mantegazza',
            redirect: '/asset/175'
        },
        {
            path: '/decleva',
            redirect: '/asset/183'
        },
        {
            path: '/cortilemaggiore',
            redirect: '/asset/234'
        },
        {
            path: '/palazzoscienze',
            redirect: '/asset/453'
        },
        {
            path: '/pololodi',
            redirect: '/asset/252'
        },
        {
            path: '/bioscienze',
            redirect: '/asset/254'
        },
        {
            path: '/informatica',
            redirect: '/asset/253'
        },
        {
            path: '/ortocittastudi',
            redirect: '/assets/105'
        },
        {
            path: '/ortobrera',
            redirect: '/assets/53'
        },
        {
            path: '/dipinto1',
            redirect: '/asset/346'
        },
        {
            path: '/dipinto2',
            redirect: '/asset/347'
        },
        {
            path: '/progrestauro',
            redirect: '/asset/215'
        },
        {
            path: '/ritrattouomo',
            redirect: '/asset/365'
        },
        {
            path: '/scettro',
            redirect: '/asset/216'
        },
        {
            path: '/sigillo',
            redirect: '/asset/217'
        },
        {
            path: '/medaglia',
            redirect: '/asset/212'
        },
        {
            path: '/medagliabozz',
            redirect: '/asset/216' // il corretto è 530 ma modificato per la presentazione per stampa sbagliata
        },
        {
            path: '/salacrociera',
            redirect: '/asset/225'
        },
        {
            path: '/gonfalone',
            redirect: '/asset/237'
        },
        {
            path: '/anello_solare',
            redirect: '/asset/668'
        },
        {
            path: '/meridiana',
            redirect: '/asset/665'
        },
        {
            path: '/orologio_solare',
            redirect: '/asset/666'
        },
        {
            path: '/quadrante1',
            redirect: '/asset/746'
        },
        {
            path: '/quadrante2',
            redirect: '/asset/759'
        },
        {
            path: '/quadrante3',
            redirect: '/asset/770'
        },
        {
            path: '/quadrante4',
            redirect: '/asset/277'
        },
        {
            path: '/quadrante5',
            redirect: '/asset/820'
        },
        {
            path: '/quadrante6',
            redirect: '/asset/669'
        },
        {
            path: '/fonografo',
            redirect: '/asset/798'
        },
        {
            path: '/narciso',
            redirect: '/asset/825'
        },
    ]
})